/**
 * 设备检测工具函数
 * 用于判断用户访问设备类型（移动端或PC端）
 */

/**
 * 检测设备类型
 * @returns {string} 'mobile' | 'pc'
 */
export function detectDeviceType() {
  // 获取用户代理字符串
  const userAgent = navigator.userAgent.toLowerCase();
  
  // 移动设备检测正则表达式
  const mobileRegex = /mobile|android|iphone|ipad|phone|tablet|touch/i;
  
  // 检测屏幕宽度（辅助判断）
  const isSmallScreen = window.innerWidth <= 768;
  
  // 综合判断：用户代理包含移动设备关键词 或 屏幕宽度较小
  const isMobile = mobileRegex.test(userAgent) || isSmallScreen;
  
  console.log('设备检测结果:', {
    userAgent,
    screenWidth: window.innerWidth,
    isMobile
  });
  
  return isMobile ? 'mobile' : 'pc';
}

/**
 * 检查是否为移动端设备
 * @returns {boolean}
 */
export function isMobileDevice() {
  return detectDeviceType() === 'mobile';
}

/**
 * 检查是否为PC端设备
 * @returns {boolean}
 */
export function isPCDevice() {
  return detectDeviceType() === 'pc';
}

/**
 * 根据设备类型返回对应的路由前缀
 * @returns {string} '/mobile' | '/desktop'
 */
export function getDeviceRoutePrefix() {
  return isMobileDevice() ? '/mobile' : '/desktop';
}

/**
 * 获取设备相关信息
 * @returns {Object} 设备信息对象
 */
export function getDeviceInfo() {
  return {
    type: detectDeviceType(),
    isMobile: isMobileDevice(),
    isPC: isPCDevice(),
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    userAgent: navigator.userAgent
  };
}

export default {
  detectDeviceType,
  isMobileDevice,
  isPCDevice,
  getDeviceRoutePrefix,
  getDeviceInfo
};